
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAACHUExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/1GL/5u8/1GK/+bv/////+bu/6jE/2qb//L3/6fF /2mb/3aj/9rm/8DW/7TN/0WC/4Ks/4Or/83d/5y9/4Kr/83e/4+0/16T/460/wAAAKfkShoAAAAS dFJOUwBAj9/PnyAQkI/PQM/PjxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEA mpwYAAAAB3RJTUUH5wwEAzkiVKWJywAAAMhJREFUKM+dkusOgjAMRutgXERFC1JAEBni9f3fz00Z UbKZ6Pm19KyDtB+AZMYc/MDlHrzwAzQQ+k/nopG5sgFaCAE8tBIBt0sGi+GUpCPboeSAvpbRSK5r o6Q3fpVFqdiZZVVL9tlfzzZ2WdUHorZG0VmeTbFMj8IsezxRn+XCKM+J/GBHhVHWJZHApjd3CjnZ htqpfA7+glc1eL0W0NFKhm3d0rv+nyWs7MvmENmljKe1lcn0xd+iCbGxl/lD5j0+6V6zjao/AChM OBuqZD6oAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIzLTEyLTA0VDAyOjMyOjEyKzAwOjAwVnioQgAA ACV0RVh0ZGF0ZTptb2RpZnkAMjAyMy0xMi0wNFQwMjozMjoxMiswMDowMCclEP4AAAAodEVYdGRh dGU6dGltZXN0YW1wADIwMjMtMTItMDRUMDM6NTc6MzQrMDA6MDCCz9vkAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    